import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { autoLoadLangs } from '@dana/components';

// 自动加载语言包
// @ts-ignore
const langContext = require.context('./lang', false, /lang\.[a-z]{2}\.json$/);
autoLoadLangs(langContext);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

function setViewport() {
  const width = window.innerWidth;
  const scale = width / 375; // 375 是你设计图的宽度
  const viewportMeta = document.querySelector('meta[name="viewport"]');

  if (viewportMeta) {
    viewportMeta.setAttribute(
      'content',
      `width=375, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no`,
    );
  } else {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = `width=375, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no`;
    document.head.appendChild(meta);
  }
}

// 在页面加载时调用该函数
window.addEventListener('load', setViewport);
// window.addEventListener('resize', setViewport); // 监听窗口大小变化

root.render(<App></App>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
